import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


function IdleMonitor() {
    //Modal
    const [idleModal, setIdleModal] = useState(false);
    const IDLE_TIMEOUT = 1000 * 60 * 20;

    let idleTimeout = IDLE_TIMEOUT;  //1 minute
    let idleLogout = IDLE_TIMEOUT; //2 Minutes
    let idleEvent;
    let idleLogoutEvent;

    /**
     * Add any other events listeners here
     */
    const events = [
        "load",
        "mousemove",
        "mousedown",
        "click",
        "scroll",
        "keypress"
    ];


    /**
     * @method sessionTimeout
     * This function is called with each event listener to set a timeout or clear a timeout.
     */
    const sessionTimeout = () => {
        if (!!idleEvent) clearTimeout(idleEvent);
        if (!!idleLogoutEvent) clearTimeout(idleLogoutEvent);

        idleEvent = setTimeout(() => logOut(), idleTimeout); //show session warning modal.
        idleLogoutEvent = setTimeout(() => logOut, idleLogout); //Call logged out on session expire.
    };

    /**
     * @method extendSession
     * This function will extend current user session.
     */
    const extendSession = () => {
        console.log('user wants to stay logged in');
    }


    /**
     * @method logOut
     * This function will destroy current user session.
     */
    const logOut = () => {
        // console.log('logging out');
        const isLogin = localStorage.getItem("loggedIn");
        if (isLogin === 'true') {
            localStorage.removeItem("currentUser");
            localStorage.removeItem('token');
            localStorage.removeItem("loggedIn");
            window.location.href = '/authentication/login';
        }
    }

    useEffect(() => {
        for (let e in events) {
            window.addEventListener(events[e], sessionTimeout);
        }

        return () => {
            for (let e in events) {
                window.removeEventListener(events[e], sessionTimeout);
            }
        }
    }, []);


    return (
        <Modal isOpen={idleModal} toggle={() => setIdleModal(false)}>
            {/* <ModalHeader toggle={() => setIdleModal(false)}>
                Session expire warning
            </ModalHeader> */}
            <ModalBody>
                Session expired?
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-info" onClick={() => logOut()}>Logout</button>
                {/* <button className="btn btn-success" onClick={()=> extendSession()}>Extend session</button> */}

            </ModalFooter>
        </Modal>
    )

}

export default IdleMonitor;